import type { ReactNode } from "react";

import { Badge } from "@/components/ui/badge";
import { cn } from "cn";

function CenteredStatusBadge({ children }: { children: ReactNode }) {
    // Full-height row centers badges within the Data Grid cell.
    return <div className="flex h-full items-center">{children}</div>;
}

function StatusCell(params: any) {
    const status = params.value?.toLowerCase();
    if (!status) {
        return null;
    }

    if (status === "baddebt") {
        return (
            <CenteredStatusBadge>
                <Badge variant="outline" className="border-destructive text-destructive capitalize">
                    Bad Debt
                </Badge>
            </CenteredStatusBadge>
        );
    }

    if (status === "cancelled") {
        return (
            <CenteredStatusBadge>
                <Badge variant="outline" className="border-destructive text-destructive capitalize">
                    {status}
                </Badge>
            </CenteredStatusBadge>
        );
    }

    if (status === "declined") {
        return (
            <CenteredStatusBadge>
                <Badge variant="destructive" className="capitalize">
                    {status}
                </Badge>
            </CenteredStatusBadge>
        );
    }

    if (status === "draft" || status === "posted") {
        return (
            <CenteredStatusBadge>
                <Badge variant="warning" className="capitalize">
                    {status}
                </Badge>
            </CenteredStatusBadge>
        );
    }

    if (status === "confirmed") {
        return (
            <CenteredStatusBadge>
                <Badge className="capitalize">
                    {status}
                </Badge>
            </CenteredStatusBadge>
        );
    }

    if (status === "approved") {
        return (
            <CenteredStatusBadge>
                <Badge variant="success" className="capitalize">
                    {status}
                </Badge>
            </CenteredStatusBadge>
        );
    }

    if (status === "acknowledged") {
        return (
            <CenteredStatusBadge>
                <Badge variant="secondary" className="capitalize">
                    {status}
                </Badge>
            </CenteredStatusBadge>
        );
    }

    return <span className={cn("capitalize")}>{status}</span>;
}

export default StatusCell;
